import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { SIUserDataPayload, SIMiscSliceState, SIStoreState } from "./store.interface";

const initialState: SIMiscSliceState = {
    userData: null,
};

const MiscSlice = createSlice({
    name: "misc",
    initialState,
    reducers: {
        setUserData: (state, action: PayloadAction<SIUserDataPayload | null>) => {
            state.userData = action.payload;
        },
    },
});

export const { setUserData } = MiscSlice.actions;
export default MiscSlice.reducer;

// Selectors
export const getUserData = () => (state: SIStoreState) => state.misc.userData;